<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool v-if="$user.group > 70" @on-submit="handleSearch">
        <el-input
          :placeholder="$t('column.l70_account')"
          v-model="searchData.username"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>

      <tg-amount-bar
        ref="amount"
        v-show="showAmount"
        :columns="amountColumns"
        :row="amountTotalData"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      :summary-method="parseSummary"
      showSummary
      :sortMethods="sortMethods"
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>
      <template slot="note" slot-scope="scope">
        <span>{{ scope.row.note }} </span>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgAmountBar from "@/components/amount/TgAmountBar";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.game.tournamentBet;

export default {
  components: {
    TgLayout,
    TgTable,
    TgUserFullName,
    TgSearchTool,
    TgAmountBar,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      amountData: {},
      amountTotalData: {},
      sortMethods: {
        dealmoney: this.sortData("dealmoney"),
      },
      searchData: {
        username: "",
      },
      showAmount: false,
      amountColumns: [],
    };
  },
  props: {
    row: Object,
  },
  created() {
    this.$store.commit("breadcrumb/clear");
    if (!this.row) {
      this.$router.push({ name: "game.tournament" });
      return;
    }
    this.addBreadcrumb();
    api.getColumns().then((response) => {
      this.columns = response.data;
      // 设置总计栏位：交易金额、结果
      this.amountColumns = [];
      if (this.columns.length > 4) {
        this.amountColumns.push(this.columns[4]); // dealmoney
      }
      if (this.columns.length > 7) {
        this.amountColumns.push(this.columns[7]); // after
      }
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  computed: {
    request() {
      return {
        eventId: this.row.eventId,
        gameName: this.row.game_name,
        gameTime: this.row.origin_gameTime || this.row.game_time,
        username: this.searchData.username,
      };
    },
    /**
     * 解析合計資訊
     */
    parseSummary() {
      let data = this.amountData ? [this.amountData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          3
        );
      };
    },
  },
  methods: {
    handleSearch() {
      this.$refs.table.search(this.request);
    },
    addBreadcrumb() {
      this.$store.commit("breadcrumb/add", {
        name: this.$route.name,
        id: this.$route.name + "_" + this.row.name,
        meta: {
          title: this.row.name,
        },
      });
    },
    handleLoaded(response) {
      this.showAmount =
        response.data.length > 0 && !("length" in response.amount);

      this.amountData = response.amount;
      this.amountTotalData = response.total;
    },
    sortData(column) {
      return (a, b) => {
        return a[column] - b[column];
      };
    },
  },
  watch: {
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
